import { resolveTerm, type SpeciesContext } from '@pedigreesmart/core'

import { it } from './locales/it.js'

export type Messages = Record<string, string>

const LOCALES: Record<string, Messages> = { it }

/**
 * Two layers, composed.
 *
 * Species terminology answers "what is this thing called in this domain"
 * (Cucciolo vs Puledro) and comes from the server as data. Locale messages
 * answer "what is this text in this language" and ship with the app.
 *
 * A key of the form `species:<term>` resolves against the species; anything
 * else resolves against the locale.
 */
export function createTranslator(locale: string, species: SpeciesContext | null) {
  const messages = LOCALES[locale] ?? LOCALES.it ?? {}

  return function t(key: string, params?: Record<string, string | number>): string {
    if (key.startsWith('species:')) {
      return resolveTerm(species, key.slice('species:'.length))
    }

    const template = messages[key] ?? key

    if (!params) return template

    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      name in params ? String(params[name]) : match,
    )
  }
}

export type Translator = ReturnType<typeof createTranslator>

export { it }
